export enum YesNoEnums {
  TRUE = "true",
  FALSE = "false",
}

export const YesNoLabelMap: Record<string, string> = {
  [YesNoEnums.TRUE]: "Yes",
  [YesNoEnums.FALSE]: "No",
};

export const YesNoRadioButtonOptions = Object.values(YesNoEnums).map(
  (value) => ({
    label: YesNoLabelMap[value] || value,
    value,
  }),
);
